import React, { useEffect, useState } from 'react';
import { StyleSheet, View, FlatList, Pressable, TouchableWithoutFeedback, Alert, Image } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { Ionicons } from '@expo/vector-icons';
import ButtonGradient from '../modules/component/ButtonGradient';
import * as Location from 'expo-location';
import { Button, Text } from 'react-native-paper';
import theme from './../../lib/theme.js';
import { AntDesign } from '@expo/vector-icons';
import { apiFetch } from '../modules/api';

function MyCheckbox(valor) {

  var estaSel = false;
  const [pIncidencia, SetPincidencia] = useState(valor.incidencia.incidencia);
  const [checked, onChange] = useState(valor.incidencia.seleccionado === "1");

  if (valor.incidencia.seleccionado === "1") {
    actualizarValor1();
  }

  function onCheckmarkPress() {
    onChange(!checked);
    actualizarValor2();
  }

  function actualizarValor1() {
    if (checked) {
      gCheckbox[pIncidencia] = 1
    } else {
      gCheckbox[pIncidencia] = 0
    }

  }

  function actualizarValor2() {
    if (!checked) {
      gCheckbox[pIncidencia] = 1
    } else {
      gCheckbox[pIncidencia] = 0
    }
  }

  return (
    <Pressable
      style={[styles.checkboxBase, checked && styles.checkboxChecked]}
      onPress={onCheckmarkPress}>
      {checked && <Ionicons name="checkmark" size={15} color="white" />}
    </Pressable>

  );
}


const Incidencias = (props) => {
  const { setSnackBarVisble, setModalVisible } = props;
  const navigation = useNavigation();

  const [isLoadingData, setIsLoadingData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);


    const showAlert = () => {
      alert(gMsg);
      navigation.goBack();
    }


  async function validarGpsEncendido() {

    let { status } = await Location.requestForegroundPermissionsAsync();

    if (status !== 'granted') {
      setErrorMsg('Permission to access location was denied');
      gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
      showAlert();
      navigation.navigate("Acceso");
      return;
    } else {
      let location = await Location.watchPositionAsync(
        {
          accuracy: Location.Accuracy.High,
          timeInterval: 5000,
          distanceInterval: 10
        },
        (loc) => {
          gGeo = loc.coords;
        }
      );
    }
  }

  async function guardarInc() {
    if(isLoading){
      return true;
    }
    setIsLoading(true);
    try {
      var altitude = gGeo.altitude
      var latitude = gGeo.latitude
      var longitude = gGeo.longitude
    } catch {

      validarGpsEncendido();
      setIsLoading(false);
    }
    var indicenciasApi = "";

    for (var i in gCheckbox) {

      if (gCheckbox[i] == 1) {

        indicenciasApi += i + '_#_';

      }

    }

    var datos = '{"operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "' + gUpc + '","tipos_incidencias" : "' + indicenciasApi.substring(0, indicenciasApi.length - 3) + '","altitude":"' + altitude + '","latitude":"' + latitude + '","longitude":"' + longitude + '"}'

    var requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos
    };

    const response = await apiFetch(gApiPath + "/api/crearIncidencia", requestOptions);
    const json = await response.json();
    if (json.estatus == "bien") {
      setSnackBarVisble(true);
      setIsLoading(false);
      setModalVisible(false);
    }

  }



  const [incidencia, setIncidencia] = useState([]);

  useEffect(function () {
    let mounted = true;
    (async () => {
      let { status } = await Location.requestForegroundPermissionsAsync();
      if (status !== 'granted') {
        setErrorMsg('Permission to access location was denied');
        navigation.navigate("Acceso");
        return;
      }

    })();

    async function fetchData() {
      const datos = '{"operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "' + gUpc + '"}'
      if (mounted) {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: datos

        }

        const response = await apiFetch(gApiPath + "/api/listarTiposIncidenciasCliente", requestOptions);
        const json = await response.json();
        setIncidencia(json.datos);
        setTimeout(() => {
          setIsLoadingData(false);
        }, 1000);
        
        gCheckbox = {};


      }

    }
    fetchData();



    return () => mounted = false; // cleanup function

  }, []);

  const Spacer = ({ height = 16 }) => <View style={{ height }} />;
  return (
    <View style={{ width: '100%' }}>
      <Text style={{ ...theme.subTitle, fontWeight: 'bold', textAlign: 'center', marginBottom: "10px" }}>Listado de incidencias </Text>
      {!isLoadingData ? (
        <FlatList
          data={incidencia}
          style={{ width: '100%', maxHeight: "300px" }}
          renderItem={({ item }) => (
            <View style={{minWidth: "100%"}}>
              <View style={styles.checkboxContainer}>
                {item.tipo.toLowerCase() === 'informativa' && (<MyCheckbox incidencia={item} />)}
                {item.tipo.toLowerCase() === 'seguimiento' && item.seleccionado === '0' && (<MyCheckbox incidencia={item} />)}
                {((item.tipo.toLowerCase() === 'seguimiento' && item.seleccionado === '1')) && (<AntDesign name="checkcircle" size={20} color={theme.colors.success} />)}
                <Text style={theme.subTitle3}>  {item.incidencia}</Text>
              </View>
            </View>)}
          keyExtractor={item => item.id}
        />
      ) : (
        <Text>Cargando...</Text>
      )}
      <View>
        <TouchableWithoutFeedback>
          <Button onPress={() => guardarInc()} disabled={isLoading || isLoadingData} loading={isLoading || isLoadingData} mode="contained" style={{ marginTop: 20, marginBottom: 10 }}>
            {!isLoading ? 'Guardar' : ''}
          </Button>
        </TouchableWithoutFeedback>
        <TouchableWithoutFeedback >
          <Button onPress={() => setModalVisible(false)} disabled={isLoading} mode="contained" style={isLoading ? {} : theme.buttons.error}>
            Cerrar
          </Button>
        </TouchableWithoutFeedback>
      </View>
    </View>
  );
}

export default Incidencias

const styles = StyleSheet.create({

  titulo: {
    fontSize: 25,
    color: "white",
    fontWeight: 'bold',
    marginTop: 10,
  }, text: {
    fontSize: 15,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  titulo1: {
    fontSize: 30,
    color: "white",
    fontWeight: 'bold',
    marginTop: 40,
  },

  titulo2: {
    fontSize: 20,
    color: "black",
    fontWeight: 'bold'
  },

  titulo3: {
    fontSize: 30,
    color: "black",
    fontWeight: 'bold'
  },
  button: {

    padding: 5,
    width: '100%',
    height: '95%',
    borderRadius: 10,
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 5,
    marginBottom: 5

  },
  container2: {
    flex: 1,
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',

  }, checkboxBase: {
    width: 20,
    height: 20,
    borderRadius: 4,
    borderWidth: 2,
    borderColor: theme.colors.warning,
  },

  checkboxChecked: {
    backgroundColor: theme.colors.warning,
  },

  checkboxContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
    width: '100%'

  },


});


